export default [{
    name: "EndOfMonth",
    path: '/end-of-month',
    component: () => import('../components/end_of_month/Index.vue'),
    meta: {
      requiresAuth: true,
      hasAccess: ['admin'],
      layout: 'master',
      re_fetch:true
    }
  }]
  